import BgConsoleCard from "../assets/console/service-card-1.webp";
import BgConsoleCard2x from "../assets/console/service-card-1@2x.webp";
import BgConsoleCard3x from "../assets/console/service-card-1@3x.webp";
import BgConsoleCardSecond from "../assets/console/service-card-2.webp";
import BgConsoleCardSecond2x from "../assets/console/service-card-2@2x.webp";
import BgConsoleCardSecond3x from "../assets/console/service-card-2@3x.webp";

export const DATAS = {
  install: {
    images: {
      src: BgConsoleCard,
      src2x: BgConsoleCard2x,
      src3x: BgConsoleCard3x,
    },
    title: "Install & Play",
    description: "Stream your games in\nthe cloud",
    btnLabel: "Explore",
  },
  download: {
    images: {
      src: BgConsoleCardSecond,
      src2x: BgConsoleCardSecond2x,
      src3x: BgConsoleCardSecond3x,
    },
    title: "Play Anywhere",
    description: "Easily play on your TV,\ndesktop or mobile devices!",
    btnLabel: "Explore",
  },
};

export const FeatureDesktopGroup = "app_content_desktop";
export const FeatureMobileGroup = "app_content_mobile";
export const EssentialPassId = "essential_pass_banner";
export const ByogId = "byog_banner";

export const ConsoleByogMobileGroup = "console_byog_mobile";
export const ConsolePidMobileGroup = "ep_top_picks";
export const SearchDefaultGamesGroup = "search_default_games";

export const ConsoleDesktopId = [
  "byog_card",
  "play_anywhere_card",
  "featured_card",
];

export const ConsoleSubscriptionId = [
  "activate_console_card",
  "subscription_expiring_card",
  "subscription_expired_card",
];

export const ConsoleMobileId = [
  "pairing_card",
  "install_pwa_card",
  "play_anywhere_card",
];

export const SLIDER_SETTINGS = {
  slidesToShow: 4,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
  autoplaySpeed: 5000,
};

export const LINK_DOWNLOAD_ANDROID =
  "https://play.google.com/store/apps/details?id=com.onmo.plus";
